import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { If, Then, Else } from 'react-if';

import axios from 'axios';
import config from 'utils/config';
import styled from 'styled-components';
import ResetPasswordForm from './ResetPasswordForm';
import ResetPasswordConfirmation from './ResetPasswordConfirmation';

const StyledDiv = styled('div')`
  margin: 24px;
  padding: 16px;
`;

class ResetPassword extends Component {
  state = {
    userEmail: undefined,
    loading: false,
    called: false,
    error: null
  };

  render() {
    const { userEmail, called, loading, error } = this.state;

    const onSubmit = async (data) => {
      this.setState({
        loading: true
      });
      axios({
        url: `${config('BFF_URL')}/reset-password`,
        method: 'POST',
        headers: {
          'x-api-key': config('API_GATEWAY_API_KEY')
        },
        data: {
          email: data.email,
          username: data.username
        }
      })
        .then(() => {
          this.setState({
            loading: false,
            called: true,
            userEmail: data.email
          });
        })
        .catch(() => {
          this.setState({
            loading: false,
            error: 'Unable to reset password'
          });
        });
    };

    return (
      <StyledDiv>
        <h1>
          <FormattedMessage id="resetPassword.title" />
        </h1>

        {error && <p>{error}</p>}

        <p>
          <If condition={called && !loading}>
            <Then>
              <ResetPasswordConfirmation email={userEmail} />
            </Then>
            <Else>
              <FormattedMessage id="resetPassword.subtitle" />
              <ResetPasswordForm onSubmit={onSubmit} loading={loading} />
            </Else>
          </If>
        </p>
      </StyledDiv>
    );
  }
}

export default ResetPassword;
